import React, { useState }                  from 'react';
import { Button, OverlayTrigger, Tooltip }  from 'react-bootstrap';
import { useSelector }                      from 'react-redux';

import MotiveForm                           from '../treatment/forms/MotiveForm';

import { AUDIENCIAS_CANCELAR }              from '../../../../data/objects';
import { CANCELADA, RECHAZADA }             from '../../../../data/audienceStates';
import { ICON_EDIT }                        from '../../../extras/icons';

import Authorities                          from '../../../../services/AuthoritiesService';



const AudienceMotives = props => {

    // --------------------------------------------------------------------------------------------
    // INICIALIZO ---------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { audience } = props;

    //Inicializo el state local
    const [ auxAudience, setAuxAudience ] = useState(audience);
    const [ show, setShow ] = useState(false);
    
    // Accedo al Store    
    const authorities = useSelector(state => state.auth.authorities);


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Analizo si puede editar el Motivo
    let canCancel = false;
    if(audience)
    {   if(audience.estado && audience.estado.id === CANCELADA)
        {   // Verifico permisos
            if(authorities && Authorities.hasPermission(authorities, AUDIENCIAS_CANCELAR))
            {   canCancel  = true;
            }
        }
    }
    
    // Manejo el cierre
    const handleClose = () => {
        setShow(false);
    }
    // Manejo la apertura
    const handleOpen = () => {
        setShow(true);
    }


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header bg-danger py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-white">MOTIVO</h6>
                    <div className="dropdown no-arrow">
                        {   canCancel
                                ? 
                                    <React.Fragment>
                                        <OverlayTrigger
                                            overlay = {
                                                <Tooltip>
                                                    Modificar Motivo    
                                                </Tooltip>
                                            }
                                            placement = "left"
                                        >
                                            <Button variant="danger" size="sm" className="float-right" onClick={handleOpen}>
                                                <ICON_EDIT />
                                            </Button>
                                        </OverlayTrigger>

                                        <MotiveForm
                                            audience={auxAudience}
                                            handleClose={handleClose}
                                            setAudience={setAuxAudience}
                                            show={show}
                                        />

                                    </React.Fragment>
                                :
                                    null
                        }
                    </div>
                </div>
                <div className="card-body">
                {   audience && (audience.estado.id === RECHAZADA || audience.estado.id === CANCELADA) ? (
                        <div className="h6 mb-0 font-weight-bold text-gray-800">
                            <div className="row">
                                <div className="col-12">
                                    <strong>{ auxAudience.motivo ? auxAudience.motivo.descripcion : ''}</strong>: { auxAudience.observacionRechazo }
                                </div>
                            </div>
                        </div>
                    ) : null
                }
                </div>
            </div>
        </div>
    );
};

export default AudienceMotives;